import { render } from "./EventStatsComponent.vue?vue&type=template&id=77723508"
import script from "./EventStatsComponent.vue?vue&type=script&lang=js"
export * from "./EventStatsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__